export { default } from './AboutPage';


// WEBPACK FOOTER //
// ./src/pages/AboutPage/index.js